import React from 'react';

import HeaderEnum from '../topLevelMenu/headerEnum';

import BaseMenu from './BaseMenu';

const ServicesMenu: React.FC = () => {
  return (
    <BaseMenu
      headerEnum={HeaderEnum.Services}
      className="services-menu"
      menuListClassName="services-menu-list"
    />
  );
};

export default ServicesMenu;
